import React from 'react';
import Icon from '@atlaskit/icon';
import type { CustomGlyphProps, IconProps } from '@atlaskit/icon/types';

const JiraTeamManagedGlyph = (props: CustomGlyphProps) => (
	<svg
		fill="none"
		height="24"
		viewBox="0 0 24 24"
		width="24"
		xmlns="http://www.w3.org/2000/svg"
		data-testid={props['data-testid']}
		aria-label={props['aria-label']}
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
		className={props.className}
	>
		<rect fill="currentColor" height="24" rx="12" width="24" />
		<g fill="inherit">
			<path d="m14.6667 12c1.1045 0 2-.8954 2-2 0-1.10457-.8955-2-2-2-1.1046 0-2 .89543-2 2 0 1.1046.8954 2 2 2z" />
			<path d="m9.33333 10c1.10457 0 1.99997-.89543 1.99997-2s-.8954-2-1.99997-2-2 .89543-2 2 .89543 2 2 2z" />
			<path
				clipRule="evenodd"
				d="m11.3333 14c0-.7367.5914-1.3333 1.3334-1.3333h4c.7366 0 1.3333.59 1.3333 1.3333v2.4867c0 2.018-6.6667 2.018-6.6667 0z"
				fillRule="evenodd"
			/>
			<path
				clipRule="evenodd"
				d="m12.6667 12c.0002-.1752-.0341-.3487-.101-.5106-.0669-.1618-.1651-.3089-.289-.4328-.1238-.1239-.2709-.2221-.4328-.289s-.3354-.1012-.5106-.1009h-3.99997c-.742 0-1.33333.598-1.33333 1.3353v2.5507c0 1.2806 2.70267 1.6786 4.6667 1.3226v-1.8713c-.0005-.2628.0509-.5231.151-.766.1002-.243.2473-.4638.4328-.6499.1856-.1861.406-.3338.6486-.4347s.5028-.1531.7656-.1534z"
				fillRule="evenodd"
			/>
		</g>
	</svg>
);

const JiraTeamManagedIcon = (props: IconProps) => <Icon {...props} glyph={JiraTeamManagedGlyph} />;

export default JiraTeamManagedIcon;
